import React from 'react';
import Steps from './Steps';
import './MainContainer.css'

function MainContainer() {
    return (
        <div className="Main-container">
            <Steps/>
        </div>
    );
}

export default MainContainer;